import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import IndicatorTooltip from './IndicatorTooltip'

const useStyles = makeStyles((theme) => ({
  warning: {
    color: theme.palette.warning.main,
  },
}))

const SuicidalityIndicator = () => {
  const styles = useStyles()

  return (
    <IndicatorTooltip title="High suicidality">
      <WarningRoundedIcon className={styles.warning} titleAccess="Suicidality warning" />
    </IndicatorTooltip>
  )
}

export default SuicidalityIndicator
